exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Spiner{width:100%;height:100%;display:flex;align-items:center;justify-content:center;flex:1}.Spiner .loader,.Spiner .loader:after,.Spiner .loader:before{background:#3aadff;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.Spiner .loader{color:#3aadff;text-indent:-9999em;margin:88px auto;position:relative;font-size:11px;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.Spiner .loader:after,.Spiner .loader:before{position:absolute;top:0;content:\"\"}.Spiner .loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.Spiner .loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/helpers/Spiner/style.scss
// module id = 2591
// module chunks = 0